import React, { useState } from 'react';

// Shortcut options for the manager
const REASON_SHORTCUTS = [
    "Payment Overdue",
    "Contract Non-Compliance",
    "Client Request",
    "Security Violation",
    "Administrative Hold"
];

const DisableServerModal = ({ server, closeModal, onConfirm, isEnabling }) => {
    const [reason, setReason] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        // If enabling, we might not force a reason, but if disabling we do.
        await onConfirm(reason);
        setIsSubmitting(false);
        closeModal();
    };

    // If we are ENABLING the server, the UI is simpler (just confirm)
    if (isEnabling) {
        return (
            <div className="modal-overlay">
                <div className="modal-content" style={{ maxWidth: '500px' }}>
                    <button className="modal-close-button" onClick={closeModal}>&times;</button>
                    <h2>Enable Server</h2>
                    <p>Are you sure you want to <strong>re-activate</strong> access for <strong>{server.server_name}</strong>?</p>
                    <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '20px' }}>
                        Users will immediately regain access to the platform.
                    </p>
                    <div className="modal-actions">
                        <button className="button-secondary" onClick={closeModal} disabled={isSubmitting}>Cancel</button>
                        <button className="button-primary" onClick={handleSubmit} disabled={isSubmitting}>
                            {isSubmitting ? 'Enabling...' : 'Confirm Enable'}
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    // If DISABLING, show the full form
    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <button className="modal-close-button" onClick={closeModal}>&times;</button>
                <h2 style={{ color: '#e74c3c' }}>Suspend Server Access</h2>
                <p>This will block <strong>ALL</strong> users on <strong>{server.server_name}</strong> from accessing the system.</p>
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Reason for Suspension (Required)</label>
                        
                        {/* Shortcut Buttons */}
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '10px' }}>
                            {REASON_SHORTCUTS.map(short => (
                                <button 
                                    key={short}
                                    type="button"
                                    className="button-secondary"
                                    style={{ fontSize: '0.75rem', padding: '4px 8px' }}
                                    onClick={() => setReason(short)}
                                >
                                    {short}
                                </button>
                            ))}
                        </div>

                        <textarea 
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            placeholder="Type specific details here (e.g., Invoice #2024-001 overdue)..."
                            required
                            style={{ minHeight: '100px' }}
                        />
                    </div>

                    <div className="modal-actions">
                        <button type="button" className="button-secondary" onClick={closeModal} disabled={isSubmitting}>Cancel</button>
                        <button 
                            type="submit" 
                            className="action-button delete" 
                            style={{ padding: '10px 20px', fontSize: '1rem' }}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? 'Suspending...' : 'Confirm Suspension'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default DisableServerModal;